module.exports = __webpack_public_path__ + "img/realNameAuth.ebc50f3b.png";